import { useState, useEffect } from 'react';
import { HeaderV2 } from '../components/landing-v2/HeaderV2';
import { HeroV2 } from '../components/landing-v2/HeroV2';
import { NeonShowcaseSlider } from '../components/landing-v2/NeonShowcaseSlider';
import { AudienceCardsV2 } from '../components/landing-v2/AudienceCardsV2';
import { StatsStripV2 } from '../components/landing-v2/StatsStripV2';
import { FeaturesV2 } from '../components/landing-v2/FeaturesV2';
import { WhyAgrosV2 } from '../components/landing-v2/WhyAgrosV2';
import { CTAV2 } from '../components/landing-v2/CTAV2';
import { IntegrationsSection } from '../components/IntegrationsSection';
import { ReferencesSection } from '../components/ReferencesSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
import { ApplicationModal } from '../components/ApplicationModal';
import { Toaster } from '../components/ui/sonner';
import { getSEOSettings } from '../lib/api';

export const LandingPage = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [formType, setFormType] = useState('courier');

  // Apply SEO settings dynamically
  useEffect(() => {
    (async () => {
      try {
        const res = await getSEOSettings();
        const seo = res.data;
        if (seo.title) document.title = seo.title;
        if (seo.description) {
          const meta = document.querySelector('meta[name="description"]');
          if (meta) meta.setAttribute('content', seo.description);
        }
        if (seo.keywords) {
          let meta = document.querySelector('meta[name="keywords"]');
          if (!meta) {
            meta = document.createElement('meta');
            meta.name = 'keywords';
            document.head.appendChild(meta);
          }
          meta.setAttribute('content', seo.keywords);
        }
      } catch {
        // Keep defaults
      }
    })();
  }, []);

  const handleApplySelect = (type) => {
    setFormType(type);
    setModalOpen(true);
  };

  return (
    <div className="min-h-screen bg-background text-foreground" data-testid="landing-page-v2">
      <HeaderV2 onApplySelect={handleApplySelect} />
      <main>
        <HeroV2 onApplySelect={handleApplySelect} />
        <NeonShowcaseSlider />
        <AudienceCardsV2 onApplySelect={handleApplySelect} />
        <StatsStripV2 />
        <FeaturesV2 />
        <WhyAgrosV2 />
        <IntegrationsSection />
        <ReferencesSection />
        <CTAV2 onApplySelect={handleApplySelect} />
        <ContactSection />
      </main>
      <Footer />
      <ApplicationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        defaultForm={formType}
      />
      <Toaster position="top-right" richColors />
    </div>
  );
};

export default LandingPage;
